import { render, staticRenderFns } from "./varosliget-promenade.vue?vue&type=template&id=79e46226&scoped=true&"
import script from "./varosliget-promenade.vue?vue&type=script&lang=js&"
export * from "./varosliget-promenade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e46226",
  null
  
)

export default component.exports